// extracted by mini-css-extract-plugin
export default {"p":"_31177170ea _406a62447c _9d506c7f6e","clr":"_24b1881e2b","dls":"_48336f6371"};